<template>
  <article :id="'post-' + id">
  <v-row no-gutters>
    <v-col cols="12">
      <v-card class="mb-6 d-flex align-center" :href="link" flat>
        <!-- <v-img :src="thumbnail"></v-img> -->
        <v-avatar size="96" class="ma-3 mb-6 d-none d-sm-flex d-md-none d-lg-flex grey lighten-5">
          <v-img :src="thumbnail"></v-img>
        </v-avatar>
        <!-- <v-img v-if="thumbnail" :src="thumbnail" class="mb-4" :aspect-ratio="16/9" cover></v-img> -->
        <div>
          <v-card-title class="ch-post__title text--caslon font-weight-bold" v-html="title"></v-card-title>
          <v-card-subtitle class="ch-post__meta py-2">
            <span v-html="postedOn"></span> <span class="secondary-X-text mx-1 grey--text text--lighten-2"> | </span>
            <!-- <span v-html="postedBy"></span> <span class="secondary--text mx-1"> | </span> -->
            <a :href="category.link" v-html="category.name" :class="category.name == 'Sponsored' ? 'accent--text' : ''"></a>
          </v-card-subtitle>
          <v-card-text>
            <slot name="default"></slot>
            <!-- <v-btn small v-if="category && category.name" depressed :color="category.name == 'Sponsored' ? 'accent' : 'primary'" dark :href="category.link" v-html="category.name"></v-btn> -->
          </v-card-text>
        </div>
      </v-card>
    </v-col>
  </v-row>
</article>
</template>

<script>
  export default {
    name: 'ArchivePost',

    props: ['id', 'image', 'title', 'category', 'posted-on', 'posted-by', 'author-image', 'link'],

    computed: {
      thumbnail() {
        return this.image ? this.image : this.authorImage
      }
    }
  }
</script>

<style lang="sass">
  .ch-post__title
    word-break: normal
  .ch-post__meta a
    text-decoration: none
</style>